// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FeatureTypeDefinition } from "./FeatureTypeDefinition";
import {
  FeatureTypeDefinitionFromJSON,
  FeatureTypeDefinitionFromJSONTyped,
  FeatureTypeDefinitionToJSON,
  FeatureTypeDefinitionToJSONTyped,
} from "./FeatureTypeDefinition";
import type { Table } from "./Table";
import { TableFromJSON, TableFromJSONTyped, TableToJSON, TableToJSONTyped } from "./Table";
import type { SpatialExtent } from "./SpatialExtent";
import {
  SpatialExtentFromJSON,
  SpatialExtentFromJSONTyped,
  SpatialExtentToJSON,
  SpatialExtentToJSONTyped,
} from "./SpatialExtent";
import type { VectorLayer } from "./VectorLayer";
import {
  VectorLayerFromJSON,
  VectorLayerFromJSONTyped,
  VectorLayerToJSON,
  VectorLayerToJSONTyped,
} from "./VectorLayer";
import type { Presentation } from "./Presentation";
import {
  PresentationFromJSON,
  PresentationFromJSONTyped,
  PresentationToJSON,
  PresentationToJSONTyped,
} from "./Presentation";

/**
 *
 * @export
 * @interface VectorMeta
 */
export interface VectorMeta {
  /**
   * A spatial bounding box of 4 floats (x1, y1, x2, y2). For WGS84 we use traditional (x=lon, y=lat) order.
   */
  envelope: Array<number>;
  /**
   *
   */
  extent: SpatialExtent;
  /**
   *
   */
  layers: Array<VectorLayer>;
  /**
   *
   */
  featureTypeDefinition?: FeatureTypeDefinition | null;
  /**
   *
   */
  styleId?: string | null;
  /**
   *
   */
  presentation?: Presentation;
  /**
   *
   */
  tables?: { [key: string]: Table };
}

/**
 * Check if a given object implements the VectorMeta interface.
 */
export function instanceOfVectorMeta(value: object): value is VectorMeta {
  if (!("envelope" in value) || value["envelope"] === undefined) return false;
  if (!("extent" in value) || value["extent"] === undefined) return false;
  if (!("layers" in value) || value["layers"] === undefined) return false;
  return true;
}

export function VectorMetaFromJSON(json: any): VectorMeta {
  return VectorMetaFromJSONTyped(json, false);
}

export function VectorMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): VectorMeta {
  if (json == null) {
    return json;
  }
  return {
    envelope: json["envelope"],
    extent: SpatialExtentFromJSON(json["extent"]),
    layers: (json["layers"] as Array<any>).map(VectorLayerFromJSON),
    featureTypeDefinition:
      json["feature_type_definition"] === undefined
        ? undefined
        : json["feature_type_definition"] === null
        ? null
        : FeatureTypeDefinitionFromJSON(json["feature_type_definition"]),
    styleId:
      json["style_id"] === undefined
        ? undefined
        : json["style_id"] === null
        ? null
        : json["style_id"],
    presentation:
      json["presentation"] == null ? undefined : PresentationFromJSON(json["presentation"]),
    tables: json["tables"] == null ? undefined : mapValues(json["tables"], TableFromJSON),
  };
}

export function VectorMetaToJSON(json: any): VectorMeta {
  return VectorMetaToJSONTyped(json, false);
}

export function VectorMetaToJSONTyped(
  value?: VectorMeta | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    envelope: value["envelope"],
    extent: SpatialExtentToJSON(value["extent"]),
    layers: (value["layers"] as Array<any>).map(VectorLayerToJSON),
    feature_type_definition: FeatureTypeDefinitionToJSON(value["featureTypeDefinition"]),
    style_id: value["styleId"],
    presentation: PresentationToJSON(value["presentation"]),
    tables: value["tables"] == null ? undefined : mapValues(value["tables"], TableToJSON),
  };
}
